import React from "react";

export default function navigation() {
  return (
    <nav className="sticky top-0 w-full, h-20 flex justify-center items-center px-8 text-white bg-zinc-900/50 backdrop-blur-sm">
      <h1 className="text-3xl text-[#edeaea]">Weather Dashboard</h1>
    </nav>
  );
}
